<template>
	<!-- <div>
		

		<hr class="hr-back" />
		<section class="d-flex align-items-center px-3 pb-3 justify-content-end">
			<b-button
				class="candash-cancelBtn pointer mr-3"
				
				>Close</b-button
			>
		</section>
	</div> -->
	<main class="height-100dvh formobile">
		<header class="mob-back-header">
			<img
				class="mr-3"
				@click="backToKanban()"
				src="../../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
			/>
			View Feedback
		</header>
		<main class="become-panel-container w-100">
			<div class="mobjd-applied-top mobjd-jobdetails">
				<section class="view-fdbk-overflow">
					<h2 class="px-3 py-4 fam-lato fw-R fs-16 color-darkblack vfd-p-0">
						Basic Info
						<span class="asterik">*</span>
					</h2>

					<section class="d-flex flex-column gap-4 px-3 vfd-p-0">
						<div class="d-flex w-100 align-items-center vdf-mob-flex">
							<div class="fam-mont fs-14 fw-LM color-344054 w-40">
								Candidate Name:
							</div>
							<div v-if="dataLoading" class="w-100 text-left">
								<b-skeleton class="text-load"></b-skeleton>
							</div>
							<b-form-input
								v-else
								:value="formattedData(feedbackForm.name)"
								class="text-field w-60"
								placeholder="-"
								disabled
							/>
						</div>
						<div class="d-flex w-100 align-items-center vdf-mob-flex">
							<div class="fam-mont fs-14 fw-LM color-344054 w-40">
								Evaluation Date:
							</div>
							<div v-if="dataLoading" class="w-100 text-left">
								<b-skeleton class="text-load"></b-skeleton>
							</div>
							<b-form-input
								v-else
								:value="evaluationDate()"
								class="text-field w-60"
								placeholder="-"
								disabled
							/>
						</div>
						<div class="d-flex w-100 align-items-center vdf-mob-flex">
							<div class="fam-mont fs-14 fw-LM color-344054 w-40">
								Panel Name:
							</div>
							<div v-if="dataLoading" class="w-100 text-left">
								<b-skeleton class="text-load"></b-skeleton>
							</div>
							<b-form-input
								v-else
								:value="feedbackForm.panelName"
								class="text-field w-60"
								placeholder="John Doe"
								disabled
							/>
						</div>
						<div class="d-flex w-100 align-items-center vdf-mob-flex">
							<div class="fam-mont fs-14 fw-LM color-344054 w-40">
								Mode of Interview:
							</div>
							<div v-if="dataLoading" class="w-100 text-left">
								<b-skeleton class="text-load"></b-skeleton>
							</div>
							<b-form-input
								v-else
								v-model="modeOfInteriew"
								class="text-field w-60"
								placeholder="John Doe"
								disabled
							/>
						</div>
						<div class="d-flex w-100 align-items-center vdf-mob-flex">
							<div class="fam-mont fs-14 fw-LM color-344054 w-40">Action:</div>
							<div v-if="dataLoading" class="w-100 text-left">
								<b-skeleton class="text-load"></b-skeleton>
							</div>
							<b-form-input
								v-else
								v-model="candidateAction"
								class="text-field w-60"
								placeholder="John Doe"
								disabled
							/>
						</div>
						<div class="d-flex w-100 align-items-center vdf-mob-flex">
							<div class="fam-mont fs-14 fw-LM color-344054 w-40">Remarks:</div>
							<div v-if="dataLoading" class="w-100 text-left">
								<b-skeleton class="text-load"></b-skeleton>
							</div>
							<b-form-input
								v-else
								v-model="feedbackForm.recruiterRemarks"
								class="text-field w-60"
								placeholder="John Doe"
								disabled
							/>
						</div>
					</section>
					<section v-if="!dataLoading" class="px-3 pt-4 vfd-p-0">
						<div
							v-for="(skill, i) in feedbackForm.customFeedback.skills"
							:key="i"
							class="fdbk-cards d-flex flex-column gap-2 mb-3"
						>
							<div class="fam-lato fw-LM fs-16 color-darkblack">skill name</div>
							<div
								v-if="skill.markingType == 'rating'"
								class="d-flex align-items-center gap-3 feedback-rating"
							>
								<div class="fam-lato fw-R fs-16 color-444444">
									Rating
									<span v-if="skill.mandatory" class="asterik">*</span>
								</div>
								<b-form-rating v-model="skill.mark" disabled></b-form-rating>
							</div>
							<div
								v-else-if="skill.markingType == 'score'"
								class="d-flex align-items-center gap-3"
							>
								<div class="fam-lato fw-R fs-16 color-444444">
									Score
									<span v-if="skill.mandatory" class="asterik">*</span>
								</div>
								<div>
									<b-form-input
										v-model="skill.mark"
										class="newInt-previewInputField-score no-spinner"
										disabled
										type="number"
									></b-form-input>
								</div>
								<div class="fam-lato fw-R fs-16 color-444444">Out of 10</div>
							</div>
							<div
								v-if="skill.commentMode"
								class="d-flex justify-content-between flex-column gap-2 fam-mont fs-14"
							>
								<span class="fw-R">
									Comments:
									<span v-if="skill.mandatory" class="asterik">*</span>
								</span>
								<b-form-textarea
									v-model="skill.comments"
									class="newInt-previewInputField"
									placeholder="Comments will be shown here"
									disabled
									rows="3"
									max-rows="4"
								></b-form-textarea>
							</div>
						</div>
						<div
							v-if="feedbackForm.screenshot"
							class="fdbk-cards d-flex flex-column gap-2"
						>
							<div
								class="fam-lato fw-LM fs-16 color-darkblack d-flex align-items-center gap-1"
							>
								<img
									src="@/assets/paneldashboard/newInt-cand-screenshot.svg"
									alt
								/>
								Candidate Screenshot
							</div>
							<div>
								<img
									:src="feedbackForm.screenshot"
									class="h-100 w-100"
									alt="Candidate Image"
								/>
							</div>
						</div>
					</section>
				</section>
			</div>
			<footer
				class="candash-modal-footer bg-white d-flex align-items-center justify-content-end"
			>
				<b-button
					class="candash-cancelBtn pointer mr-3"
					@click="!isLaptop ? backToKanban() : $emit('close-modal')"
					>Close</b-button
				>
				<!-- <div class="position-relative">
					<b-button
						class="candash-addBtn pointer"
						:class="!loading ? 'pointer' : 'opac-5'"
						@click="loading ? '' : submitFeedback()"
					>
						<span :class="loading ? 'invisible' : 'pointer'">Send</span>
					</b-button>
					<div v-if="loading" class="loader-pos-new">
						<Loader />
					</div>
				</div> -->
			</footer>
		</main>
	</main>
</template>

<script>
import {
	formattedData,
	formattedDate,
} from "@/components/PanelDasboard/panelHelpers";
import { getFeedBackForm } from "../../../utils/apiFunctions";
export default {
	name: "ViewFeedback",
	props: {
		showViewFeedback: Boolean,
		interview: Object,
	},
	data() {
		return {
			dataLoading: false,
			feedbackForm: {},
			mark: 4,
			isLaptop: true,
		};
	},
	created() {
		this.getFeedback();
	},
	computed: {
		candidateAction() {
			if (
				this.feedbackForm.recommendation == "S" ||
				this.feedbackForm.recommendation == "F"
			) {
				return "Selected";
			} else if (this.feedbackForm.recommendation == "R") {
				return "Rejected";
			} else if (this.feedbackForm.recommendation == "NI") {
				return "Not Interested";
			} else if (this.feedbackForm.recommendation == "H") {
				return "On Hold";
			} else if (this.feedbackForm.recommendation == "DNA") {
				return "No Show";
			}
			return "";
		},
		modeOfInteriew() {
			return this.feedbackForm.customFeedback.basicInfo.modeOfInterview == "f2f"
				? "Face to Face"
				: "Assessment";
		},
	},
	mounted() {
		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.checkScreenSize);
	},
	methods: {
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
		backToKanban() {
			if (this.$route.query.frompage == "PanelInterviews") {
				this.$router.push({
					name: this.$route.query.frompage,
					params: {
						level: this.$route.query.level,
					},
				});
			} else {
				let queryValue = JSON.parse(JSON.stringify(this.$route.query));
				delete queryValue.frompage;
				delete queryValue.candidateID;
				delete queryValue.jobID;
				this.$router.push({
					name: this.$route.query.frompage,
					query: queryValue,
				});
			}
			// if (this.$route.query.from == "JobDetails") {
			// 	if (this.$route.query.backto && this.$route.query.level) {
			// 		this.$router.push({
			// 			name: "JobDetails",
			// 			query: {
			// 				from: this.$route.query.backto,
			// 				level: this.$route.query.level,
			// 			},
			// 		});
			// 	} else {
			// 		this.$router.push({
			// 			name: "JobDetails",
			// 		});
			// 	}
			// } else {
			// 	this.$router.push({
			// 		name: "PanelDashboard",
			// 	});
			// }
		},
		evaluationDate() {
			return formattedDate(this.feedbackForm.customFeedback.basicInfo.evalDate);
		},
		formattedData(data) {
			return formattedData(data);
		},
		async getFeedback() {
			this.dataLoading = true;
			try {
				let payload = {
					candidateID:
						this.$route.name == "ViewFeedback"
							? this.$route.query.candidateID
							: this.interview.candidateID,
					jobID:
						this.$route.name == "ViewFeedback"
							? this.$route.query.jobID
							: this.interview.jobID,
					interviewRequestID:
						this.$route.name == "ViewFeedback"
							? this.$route.query.interviewRequestID
							: this.interview.interviewRequestID,
				};
				const res = await getFeedBackForm(payload);
				if (res.status == 200) {
					this.feedbackForm = res.data.data[res.data.data.length - 1];
					this.dataLoading = false;
				}
			} catch (error) {
				this.dataLoading = false;
				console.error(error);
			}
		},
	},
};
</script>

<style scoped>
.feedback-rating .form-control {
	color: #20639b;
	background-color: transparent;
	border: none;
	width: unset;
	height: unset;
	padding: 0rem;
}
.text-load {
	height: 37px;
	border-radius: 8px;
}

.text-field.form-control {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 10px 14px;
	gap: 8px;
	background: #f6f6f6;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
	font-family: "Montserrat";
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 17px;
	color: #333333;
	border: unset;
	padding: 0px 10px;
}

.fdbk-cards {
	box-sizing: border-box;
	background: #f6f6f6;
	border: 1px solid rgba(140, 140, 140, 0.33);
	border-radius: 8px;
	padding: 10px;
}

.newInt-previewInputField-score.form-control {
	background: #ffffff;
	border: 1px solid #d0d5dd;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	color: #000000;
	width: 44px;
	height: 37px;
	padding: 0px 10px;
}

.newInt-previewInputField.form-control {
	background: #ffffff;
	border: 1px solid #d0d5dd;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	color: #000000;
}

.view-fdbk-overflow {
	height: calc(100vh - 255px);
	max-height: 900px;
	overflow: auto;
}

.color-darkblack {
	color: #000000 !important;
}

.color-344054 {
	color: #344054 !important;
}

.color-444444 {
	color: #444444 !important;
}

.color-mainblue {
	color: #20639b !important;
	/* #20639b */
}

h1,
h2,
h3,
h4,
h5,
h6 {
	margin-bottom: 0px !important;
}

@media (max-width: 1028px) {
	.view-fdbk-overflow {
		height: calc(100vh - 190px);
	}
	.vfd-p-0 {
		padding: 0 !important;
		margin-bottom: 20px !important;
		gap: 20px !important;
	}
	.vdf-mob-flex {
		flex-direction: column;
		align-items: flex-start !important;
		gap: 5px;
	}
}
@media (min-width: 1029px) {
	.formobile .become-panel-container {
		background-color: unset;
		height: unset;
		padding: unset;
		top: unset;
		position: unset;
		display: unset;
		flex-direction: column;
	}

	.formobile .mobjd-applied-top {
		height: unset;
		overflow-y: unset;
		overflow-x: unset;
	}

	.formobile .mobjd-jobdetails {
		background-color: unset;
		border-radius: unset;
		width: unset;
		padding: unset;
		padding-bottom: 10px;
	}
	.formobile .candash-modal-footer {
		border-radius: 0 0 12px 12px;
	}
}
</style>
